<template>
  <div>
    <a href="#main-content" class="skip-link link-underline-light fw-bold notes" aria-label="Aller directement au contenu">Aller au contenu principal</a>
    <Navbar />
    <ClientOnly>
  <CookieConsent />
</ClientOnly>

<!-- À ajouter quelque part dans le layout ou cette page -->
<div class="sr-only" aria-live="polite">{{ liveMessage }}</div>
<noscript>
  <div class="alert alert-warning" role="alert">
    JavaScript est désactivé dans votre navigateur. Certaines fonctionnalités comme l’achat et la lecture vidéo peuvent ne pas fonctionner.
  </div>
</noscript>


  <div class="nuxt-page-wrapper">
  <NuxtPage />
</div>

    <!-- 🔝 Bouton Retour en haut -->
<!-- Bouton Retour en haut -->
<button
  class="scroll-top-btn"
  @click="scrollToTop"
  aria-label="Retour en haut de page"
  v-show="showScrollButton"
>
  ⬆️
</button>


    <Footer ref="footerRef" />

  </div>
</template>

<script setup>
import Navbar from "~/components/Navbar.vue";
import Footer from "~/components/Footer.vue";
import { useAuthStore } from "~/stores/authStore";
import { ref, onMounted,onUnmounted, watch  } from "vue";
import { useState } from "#imports"; // ✅ Correct pour Nuxt 3
import CookieConsent from "@/components/CookieConsent.vue";

import { useCookieConsentStore } from '@/composables/useCookieConsentStore'



import { useFetch } from '#app'

const authStore = useAuthStore()


const { cookieConsent, loadExternalScripts } = useCookieConsentStore()
// Option B – via inject():
// const userLang = inject('userLang')

// --- Récupération de userLang depuis le plugin ---
const { $userLang: userLang } = useNuxtApp()

// Réagir aux changements de langue
watch(userLang, (newLang) => {
  console.log('Langue utilisateur →', newLang)
})
// maintenant `userLang.value` contient la langue, et réagira aux changements
watch(cookieConsent, (newVal) => {
  if (newVal === 'true') {
    loadExternalScripts()
  }

  // 🧼 Forcer affichage de la bannière si reset
  if (newVal === undefined) {
    console.log("🍪 Consent reset → bannière à réafficher")
  }
})






const liveMessage = ref("");
const showScrollButton = ref(false);

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const handleScroll = () => {
  showScrollButton.value = window.scrollY > 300;
};


onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

// ✅ Tableau des images d’arrière-plan
const images = [
"https://i.postimg.cc/4yKHk4jw/header-bg.jpg",
"https://i.postimg.cc/qvHwLWCW/image-bg-1.webp",

  "/images/image-bg-2.webp",
 "/images/hero2.webp",
// "/images/hero2.jpg",
 "/images/hero3.png",
 "https://i.postimg.cc/t4qsVmFs/DALL-E-2025-03-15-16-37-54-Ultra-realistic-photograph-of-an-Afro-descendant-man-studying-at-a-cozy.webp",
 "https://i.postimg.cc/wj4myy7M/DALL-E-2025-03-15-16-41-46-Ultra-realistic-photograph-of-an-Afro-descendant-man-deeply-engaged-in.webp",
 "https://i.postimg.cc/gkBnDwPZ/intructor-3x.webp",
 "https://i.postimg.cc/xjw1RPCh/assets-task-01jrvcnz2zem19cjphbw7phdqp-img-0.webp",
  "/images/image-bg-4.webp",
  "https://i.postimg.cc/W3DsmDPs/assets-task-01jrvchpnbez5s4f9pjxpcgaz7-img-0.webp",
  "https://i.postimg.cc/TPg9K0Kx/assets-task-01jrvcqmy7emebhp2mw8gpcqbj-img-0.webp",
  "https://i.postimg.cc/PJRzygj8/me-1x.webp"
];

//const CHANGE_INTERVAL = 48 * 60 * 60 * 1000; // 48 heures en millisecondes
const CHANGE_INTERVAL = 30 * 1000; // 30 secondes en millisecondes


function getCurrentImage() {
  if (typeof window === "undefined") return images[0]; // ✅ Protection en SSR


  let storedData = null;
let now = null;
if (import.meta.env.SSR) {
  storedData = JSON.parse(localStorage.getItem("pageHeaderImage"));
  now = Date.now();
}


  if (storedData) {
    const { lastUpdated, currentIndex } = storedData;
    console.log("🕒 Temps écoulé :", now - lastUpdated, "ms");

    if (now - lastUpdated >= CHANGE_INTERVAL) {
      // ✅ Mise à jour de l'image après 30 secondes
      const newIndex = (currentIndex + 1) % images.length;
      localStorage.setItem(
        "pageHeaderImage",
        JSON.stringify({ currentIndex: newIndex, lastUpdated: now })
      );
      //localStorage.removeItem("cookiesAccepted");

      console.log("📸 Nouvelle image appliquée :", images[newIndex]);
      return images[newIndex];
    }
    return images[currentIndex];
  }

  // ✅ Première image si rien n'est stocké
  localStorage.setItem(
    "pageHeaderImage",
    JSON.stringify({ currentIndex: 0, lastUpdated: Date.now() })
  );
  return images[0];
}

// ✅ Stocker l’image de fond globalement
//const headerImage = useState("headerImage", () => ref(""));
const headerImage = useState("headerImage", () => "");
useHead({
  style: [
    {
      children: `
        .page-header {
          background-image: url(${headerImage.value});
          transition: background-image 1s ease-in-out;
        }
      `,
    },
  ],
});
onMounted(async () => {
  if (cookieConsent.value === 'true') {
  await loadExternalScripts()
  }
 
  headerImage.value = getCurrentImage();
  window.addEventListener("scroll", handleScroll);


})

</script>

<style scoped>
.nuxt-page-wrapper {
  min-height: 70vh;
  padding: 20px;
}

.scroll-top-btn {
  position: fixed;
  bottom: 25px;
  right: 25px;
  z-index: 8000; 
  background-color: #ff4500;
  color: white;
  border: none;
  padding: 14px 16px;
  font-size: 20px;
  border-radius: 50%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  will-change: transform;

}

.scroll-top-btn:hover {
  background-color: #e03e00;
  transform: scale(1.1);
}

.scroll-top-btn:focus {
  outline: 2px dashed #fff;
  outline-offset: 4px;
}

.skip-link {
  position: fixed;
  top: -100px;
  left: 16px;
  z-index: 9999;
  background: #ff4500;
  color: #fff;
  padding: 12px 20px;
  font-weight: bold;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  transition: top 0.3s ease;
  text-decoration: none;
  font-size: 1rem;
}

.skip-link:focus {
  top: 16px;
}


</style>
